module.exports = __webpack_public_path__ + "static/media/entry.ea5a0213.svg";